// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "etn-norton-mello.firebaseapp.com",
  "projectId": "etn-norton-mello",
  "storageBucket": "etn-norton-mello.appspot.com",
  "messagingSenderId": "972127788193",
  "appId": "1:972127788193:web:0a2d7344b8da50fd5fa4e0",
  "measurementId": "G-PP09S24H6C",
  "apiKey": "AIzaSyCwcnJW2Kl4REtPooEdwGEZryCyDtQVwjQ"
};
